import CVV_HELP_ICON from './assets/cvvhelp.svg';
import AMEX_CVV_HELP_ICON from './assets/amexcvv.svg';
import NORMAL_CVV_HELP_ICON from './assets/cvv_normal_card.svg';

export const CardVerificationValueComponent = {
    template: `
    <oo-input-container class="icon-right">
        <img class="icon" ng-click="$ctrl.showCVVHelp()" ng-src="${CVV_HELP_ICON}"/>
        <input
            autocomplete="cc-csc"
            id="card-verification-value"
            name="cvc"
            ng-model="$ctrl.currentPayment.securityCode"
            ng-required="true"
            type="tel"
            ui-mask-placeholder-char="space"
            ui-mask="{{$ctrl.CreditCardIdentifierService.securityCodeMask}}"
            ui-options="$ctrl.options"
        />
        <label>CVV</label>
        <div ng-messages="$ctrl.form.cvc.$error">
            <div ng-messages-include="generic-messages"></div>
            <div ng-message="mask">Enter a valid CVV</div>
        </div>
    </oo-input-container>
    `,
    bindings: {
        currentPayment: '<',
        form: '<'
    },
    controller: class {
        constructor(CreditCardIdentifierService, blockingCalloutService) {
            'ngInject';
            Object.assign(this, { CreditCardIdentifierService, blockingCalloutService });

            // TODO consolidate common options.
            this.options = { clearOnBlur: false, allowInvalidValue: true, addDefaultPlaceholder: false };
        }

        showCVVHelp() {
            let element = angular.element(
                `
                <div class="cvv-modal">
                    <h1>CVV</h1>
                    <p>A three or four digit security code found on your card.</p>
                    <img ng-src="${AMEX_CVV_HELP_ICON}">
                    <img ng-src="${NORMAL_CVV_HELP_ICON}">
                </div>
                `
            );
            this.blockingCalloutService.show(element);
        }
    }
};
